export const SET_INVITE_FRIEND_STATUS = 'SET_INVITE_FRIEND_STATUS';
export const SET_INVITE_FRIEND_ADDRESS = 'SET_INVITE_FRIEND_ADDRESS';
export const SET_REFERRAL_CODE = 'SET_REFERRAL_CODE';
export const SET_REFERRAL_BALANCE = 'SET_REFERRAL_BALANCE';
export const SET_REFERRAL_BENEFICIARIES = 'SET_REFERRAL_BENEFICIARIES';

